import { render, staticRenderFns } from "./OneNewsCreate.vue?vue&type=template&id=0c1bb6de&scoped=true&"
import script from "./OneNewsCreate.vue?vue&type=script&lang=js&"
export * from "./OneNewsCreate.vue?vue&type=script&lang=js&"
import style0 from "./OneNewsCreate.vue?vue&type=style&index=0&id=0c1bb6de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1bb6de",
  null
  
)

export default component.exports